export default {
  state: {
    isLoading: false
  },

  getters: {
    getIsLoading: state => state.isLoading
  },

  mutations: {
    SET_IS_LOADING: (state, flag) => {
      state.isLoading = flag;
    }
  },

  actions: {
    LOADING: (state, flag) => {
      state.commit('SET_IS_LOADING', flag);
    }
  },

  namespaced: true
};
